var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": _vm.isDialog ? "119211" : "119210",
                  "expand-adv": true,
                  "show-simple": false,
                  "custom-search-items": _vm.customSearchItems
                },
                on: { advSearchItemCallBack: _vm.queryHandler }
              },
              [
                !_vm.isDialog
                  ? _c(
                      "template",
                      { slot: "operations" },
                      [
                        _vm.$checkPermission(["button_InvoicePool_delete"])
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "danger" },
                                on: { click: _vm.deletes }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                            )
                          : _vm._e(),
                        _vm.$checkPermission(["button_InvoicePool_getInvoice"])
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.getInvoice }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_GetInvoice"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.$checkPermission([
                          "button_ACInvoice_receiptAssociation"
                        ])
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.collectionAssociation }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_InvoiceAssociation")
                                  )
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            ),
            _c(
              "div",
              { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
              [
                _c("cargo-ag-grid-wrapper", {
                  staticStyle: { "min-height": "350px", height: "100%" },
                  attrs: {
                    "config-module": _vm.isDialog ? "2025080402" : "2025080401",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "show-selected-color": false,
                    "check-sub-record": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": _vm.isDialog ? "2025080402" : "2025080401",
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.fetchDataByPage
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm.collectionAssociationChargeDialog.visible
          ? _c("collection-association-charge-dialog", {
              attrs: {
                visible: _vm.collectionAssociationChargeDialog.visible,
                "search-item-module":
                  _vm.collectionAssociationChargeDialog.searchItemModule,
                "default-conditions":
                  _vm.collectionAssociationChargeDialog.addChargeCondition
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(
                    _vm.collectionAssociationChargeDialog,
                    "visible",
                    $event
                  )
                },
                addChargeCallBackEvent: _vm.addChargeCallBack
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }